import { AddIcon, DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Circle,
  Flex,
  FormLabel,
  Grid,
  IconButton,
  Input,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { Fragment, useEffect, useState } from "react";
import { useProfile } from "@/contexts/ProfileContext";
import { AWARD_LEVEL_OPTIONS } from "@/utils/profile";
import { createSelectOptions } from "@/utils/ui/select-helper";
import { useEditProfileContext } from "./edit/shared";
const awardLevelOptions = createSelectOptions(AWARD_LEVEL_OPTIONS);

const Awards = () => {
  const { profile } = useProfile();
  return (
    <Box bg="whiteAlpha.700" p={5}>
      <Grid gridTemplateColumns="2rem 1fr" fontWeight="bold" alignItems="center" gap={6}>
        {profile.awards.map(({ description, level }, i) => (
          <Fragment key={i}>
            <Circle fontFamily="heading" bg="yellow.300" fontSize="3xl" px={5}>
              {i + 1}
            </Circle>
            <Box>
              <Text fontSize="xl">{description}</Text>
              <Text fontSize="lg" fontWeight="normal">
                ({level})
              </Text>
            </Box>
          </Fragment>
        ))}
      </Grid>
    </Box>
  );
};

export const EditableAwardsList = () => {
  const { initialProfileData, update } = useEditProfileContext();
  const [awards, setAwards] = useState(initialProfileData.awards);

  useEffect(() => update("awards", awards), [awards]);

  return (
    <Box mt={4}>
      <Flex>
        <Spacer />
        <Button
          colorScheme="green"
          leftIcon={<AddIcon />}
          my={4}
          isDisabled={awards.length >= 5}
          onClick={() => {
            setAwards([...awards, { level: "", description: "" }]);
          }}
        >
          Add Award
        </Button>
      </Flex>
      {awards.length > 0 && (
        <Grid templateColumns="3fr 8fr 1fr" rowGap={1} columnGap={4}>
          <FormLabel fontSize="xl">Award Level</FormLabel>
          <FormLabel fontSize="xl">Description</FormLabel>
          <Box />
          {awards.map(({ description, level }, i) => {
            const onUpdateField = (fieldName, value) => {
              const newAwards = [...awards];
              newAwards[i][fieldName] = value;
              setAwards(newAwards);
            };
            const onDelete = () => {
              const newAwards = [...awards];
              newAwards.splice(i, 1);
              setAwards(newAwards);
            };

            return (
              <Fragment key={i}>
                <Select
                  value={{ label: level, value: level }}
                  options={awardLevelOptions}
                  placeholder="Level"
                  variant="filled"
                  onChange={(e) => onUpdateField("level", e.value)}
                />
                <Input
                  value={description}
                  placeholder="Description"
                  variant="unstyled"
                  onChange={(e) => onUpdateField("description", e.target.value)}
                />
                <IconButton
                  colorScheme="red"
                  variant="ghost"
                  icon={<DeleteIcon />}
                  onClick={onDelete}
                />
              </Fragment>
            );
          })}
        </Grid>
      )}
    </Box>
  );
};

export default Awards;
